// extracted by mini-css-extract-plugin
export var content = "ModalButton-module--content--909b3";
export var hasTextWeightBold = "ModalButton-module--has-text-weight-bold--cd513";
export var isUppercase = "ModalButton-module--is-uppercase--c8ad3";
export var root = "ModalButton-module--root--3c347";
export var secondary = "ModalButton-module--secondary--51474";